import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { uniq } from 'lodash';
import { TreasurehuntService } from 'src/app/services/treasureHunt/treasurehunt.service';
import { where } from '@angular/fire/firestore';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-add-user-for-action',
  templateUrl: './add-user-for-action.page.html',
  styleUrls: ['./add-user-for-action.page.scss'],
  standalone: false,
})
export class AddUserForActionPage extends BaseInjectorService implements OnInit {

  usersListing: boolean = false;
  siteManagerInfo : any = {};
  siteOwnerInfo : any = {};



  model: any = {};
  keyboardHeight = 0;
  usersList: any;
  searchControl: any;
  searching: any;
  siteManagerEmail: any;
  areaOwnerEmail: any;
  action_data: any;
  dwkWorkGroupManagerId: any;
  lastFiveAssignedTo: any = [];
  assignedZone: boolean = false;
  showSkeleton: boolean = true;
  lastFiveAssgin: any = [];
  mode: any;
  fromPage: any;
  copyUserList: any = [];
  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    public treasurehuntService: TreasurehuntService
  ) {
    super();

    this.searchControl = new FormControl();
  }

  ngOnInit() {
    this.lastFiveAssignedTo = [];
    this.appService.initAppData(this.route);
  
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener('keyboardWillShow', (info) => {
        this.keyboardHeight = info.keyboardHeight; // in px
        setTimeout(() => {
          const el = document.querySelector('input:focus');
          el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      });

      Keyboard.addListener('keyboardWillHide', () => {
        this.keyboardHeight = 0;
      });
    }
  }

  async ionViewDidEnter() {
    this.getLastFiveAssignedTo();
    this.searchControl.setValue('');

  console.log('siteOwnerInfo', this.siteOwnerInfo);
  console.log('siteManagerInfo', this.siteManagerInfo);

    let siteOwnerDetails = this.findUserDetails(this.siteOwnerInfo.email);
    this.siteOwnerInfo.person_unique_id = siteOwnerDetails?.person_unique_id || "";

    let siteManagerDetails = this.findUserDetails(this.siteManagerInfo.email);
    this.siteManagerInfo.person_unique_id = siteManagerDetails?.person_unique_id || "";
    



   this.showSkeleton = false;
    let usersList = this.appService.appData.usersByCountry.filter((element: any) => {
      const firstName = element.Fname || element.first_name || element.First_Name || '';
      const lastName = element.Lname || element.last_name || element.Last_Name || '';
      const full_name = element.Full_Name || element.full_name || `${firstName} ${lastName}`.trim();
      // Ensure all name fields are set
      element['Full_Name'] = full_name;
      element['Fname'] = firstName;
      element['Lname'] = lastName;
      element['First_Name'] = firstName;
      element['Last_Name'] = lastName;
      element['full_name'] = full_name;
      if (element.person_id) {
        return true;
      } else {
        return false;
      }
    });

    this.usersList = usersList.sort((a, b) => a.email.localeCompare(b.email));
    this.copyUserList = usersList.sort((a, b) => a.email.localeCompare(b.email));
    this.searchService.item = this.usersList;
    this.setSearchedPolicy('');

    this.searchControl.valueChanges.pipe(debounceTime(700)).subscribe(async (search: any) => {
      this.searching = false;
     // if (Capacitor.isNativePlatform()) await Keyboard.hide();
     // this.setSearchedPolicy(search);
    });
  }

  selectUser(user) {
    this.closeModal(user);
  }

  async getLastFiveAssignedTo() {
    let lastFiveAssignedToUserList = await this.lhStorage.get('lastFiveAssignedToUsers');
    this.lastFiveAssignedTo = lastFiveAssignedToUserList ? lastFiveAssignedToUserList : [];
  }





  setSearchedPolicy(searchTerm) {
    if(!searchTerm || searchTerm==""){
      this.usersListing = false;
      return;
    }
    const query = searchTerm.toLowerCase(); 

    this.usersList = this.copyUserList.filter((item) => {
      return (
        item.id.toLowerCase().includes(query) ||
        item.Fname?.toLowerCase().includes(query) ||
        item.Lname?.toLowerCase().includes(query) ||
        item.first_name?.toLowerCase().includes(query) ||
        item.full_name.toLowerCase().includes(query)
      );
    });

  }


  userSelected(user: any) {
    console.log(user);
    const userDetail = this.usersList.find((element) => element.id === user.id);
    this.logger.log('USER SELECTED IS :', user);
    this.closeModal({
      email: userDetail.id,
      person_unique_id: userDetail.unique_id,
      selected_user: userDetail,
    });
    // const userDetail = this.usersList.find((element) => element.email === event.detail.value);
    // this.logger.log("USER SELECTED IS :", userDetail);
    // this.closeModal({ email: userDetail.email });
  }

  closeModal(selectedUser) {
    this.modalController.dismiss({
      selectedUser: selectedUser
    });
  }
  onClose() {
    this.modalController.dismiss();
  }


 findUserDetails(email: any){
    let userDetails = this.appService.appData.usersByCountry.find((element: any) => {
        return  element.email == email;
    })
    console.log("-------",userDetails);
    return userDetails;
 }

  onSearchFocus(event){
    this.usersListing = true;
  }
  onSearchClear(event){
    console.log('clear event',event);
    this.usersListing = false;
    this.usersList = JSON.parse(JSON.stringify(this.copyUserList));
    this.setSearchedPolicy('');
  }

  onSearchInput(event) {
    console.log(event.target.value)
    let searchTerm = event.target.value;
    this.setSearchedPolicy(searchTerm);
    this.usersListing = true;
  }

  onSelectManager(data){
      this.closeModal({
          email: this.siteManagerInfo?.id,
          person_unique_id: this.siteManagerInfo?.person_unique_id,
          Fname : this.siteManagerInfo?.first_name,
          Lname : this.siteManagerInfo?.last_name
        });
  }


  onSelectOwner(data){
      this.closeModal({
          email: this.siteOwnerInfo?.id,
          person_unique_id: this.siteOwnerInfo?.person_unique_id,
          Fname : this.siteOwnerInfo?.assign_to,
          Lname : ""
        });
  }

}
